export default __webpack_public_path__ + "static/planet1-ecaa9e9fb539335e983b0b87d7e9d977.png";